module.exports = __webpack_public_path__ + "static/img/IMG_20241208_184252.b102e50f.jpg";